import { requests } from "../../requests";
import { mergeProjectUrl } from "../../http/config";
import { EndPoints } from "../../utils/EndPoints";

export const quantityOverviewService = {
  // ?type=table is paginated server-side (page_size=100, max_page_size=500).
  // Fetches one page at a time; pass a prior response's `next` URL to page
  // forward (e.g. on scroll), or omit it to fetch page 1.
  getPage: async (nextUrl) => {
    try {
      const options = nextUrl
        ? { method: "GET", url: nextUrl }
        : {
            method: "GET",
            url: mergeProjectUrl(EndPoints.Reports.dashboardQuantity),
            params: { type: "table" },
          };
      const response = await requests(options);

      if (!response || response.error) {
        return { error: true, data: response?.data || "Error fetching quantity dashboard" };
      }

      return {
        error: false,
        results: response.data?.results || [],
        next: response.data?.next || null,
        count: response.data?.count || 0,
      };
    } catch (error) {
      return { error: true, data: error?.message || "Error fetching quantity dashboard" };
    }
  },
};

// Rows come from GET reports/dashboard/quantity/?type=table — one row per
// active PurchaseOrder: { id, po_number, so_number, so_quantity, po_quantity,
// cargo_received_quantity, balance_to_purchase, status, miller, broker, contract_date }
export const computeOverview = (rows = []) => {
  const poCreated = rows.reduce((sum, row) => sum + (Number(row.po_quantity) || 0), 0);
  const cargoReceived = rows.reduce(
    (sum, row) => sum + (Number(row.cargo_received_quantity) || 0),
    0
  );
  const balanceToPurchase = poCreated - cargoReceived;

  // Multiple PO rows can share the same sales order, so dedupe by so_number
  // before summing SO quantity.
  const soQuantityByNumber = new Map();
  rows.forEach((row) => {
    const key = row.so_number || row.id;
    if (key && !soQuantityByNumber.has(key)) {
      soQuantityByNumber.set(key, Number(row.so_quantity) || 0);
    }
  });
  const salesTotal = Array.from(soQuantityByNumber.values()).reduce((sum, v) => sum + v, 0);

  return { salesTotal, poCreated, cargoReceived, balanceToPurchase };
};
